import { NgModule } from '@angular/core';
import { UILoaderComponent } from './ui-loader.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#00ACC1",
  bgsOpacity: 0,
  bgsPosition: "bottom-right",
  bgsSize: 60,
  bgsType: "ball-spin-clockwise",
  blur: 0,
  fgsColor: "#ff4a4a",
  fgsPosition: "center-center",
  fgsSize: 60,
  fgsType: "ball-spin-clockwise",
  gap: 24,
  logoPosition: "center-center",
  logoSize: 120,
  logoUrl: "",
  overlayColor: "rgba(40, 40, 40, 0.2)",
  pbColor: "#ff4a4a",
  pbDirection: "ltr",
  pbThickness: 3,
  hasProgressBar: true,
  text: "",
  textColor: "#FFFFFF",
  textPosition: "center-center"
};

@NgModule({
  declarations: [
    UILoaderComponent
  ],
  imports: [
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
  ],
  exports : [
    UILoaderComponent
  ]
})
export class UILoaderModule { }
